"use client"

import { RotateCwSquare } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `RotateCwSquareIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const RotateCwSquareIcon = component(Icon)({ as: RotateCwSquare })
